export default __webpack_public_path__ + "static/media/img_distribution-graph01-m.c0dd26a4.png";